import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    isLoading: {
        rule: false,
        taxonomy: false
    },
    isSearching: false,
    displayingSearch: false,
    searchedCustomSegmentParents: [],
    lastUuRequestKey: null,
    activeTab: 'information',
    hierarchies: {
        //[customTaxo.id]: [cs list],
    },
    selectedTaxoId: null,
    selectedSegmentId: null,
    ruleEstimations: {},
    isRuleValid: null,
    formSegment: {
        displayModal: false,
        type: 'create',
        activeTab: 'information'
    },
    newCSParentId: null,
    newCSSiblings: [],
    counters: {
        dragged: 0,
        created: 0,
        updated: 0,
        deleted: 0
    },
    updatedSegmentIds: [],
    createdSegmentKeys: [],
    formTaxonomy: {
        displayModal: false,
        type: 'create'
    },
    displaySharingTaxonomyModal: false,
    selectedSharingTaxonomy: null,
    isProcessing: false,
    hasCounterActivated: false
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
